import React from 'react';

function BetaLabel() {
  return (
    <span className="ws-ui-beta-label">
      <svg
        width="29"
        height="14"
        viewBox="0 0 29 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.43 11a.27.27 0 0 1-.2-.08.27.27 0 0 1-.07-.2V3.58c0-.09.02-.15.07-.2a.27.27 0 0 1 .2-.08H4.7c.6 0 1.1.09 1.5.26.38.18.67.43.85.75.2.32.29.7.29 1.14 0 .27-.05.5-.16.71a1.73 1.73 0 0 1-.77.8c.29.14.54.36.75.66.22.3.33.66.33 1.08 0 .46-.1.87-.3 1.21-.21.35-.52.61-.92.8-.4.2-.9.29-1.47.29H1.43ZM2.9 9.71H4.6c.36 0 .63-.1.81-.3.19-.2.28-.44.28-.72 0-.29-.1-.52-.29-.71-.18-.2-.45-.3-.8-.3H2.9V9.7Zm0-3.3H4.5c.34 0 .6-.08.77-.25a.9.9 0 0 0 .26-.67.84.84 0 0 0-.26-.65c-.17-.17-.43-.25-.77-.25H2.9V6.4ZM9.08 11a.27.27 0 0 1-.2-.08.27.27 0 0 1-.08-.2V3.58a.27.27 0 0 1 .28-.27h4.98c.08-.01.15.02.2.07.05.05.08.11.08.2v.88c0 .07-.03.13-.08.18a.27.27 0 0 1-.2.08H10.5v1.73h3.32c.08 0 .15.02.2.07.05.05.08.12.08.2v.82c0 .07-.03.13-.08.18a.27.27 0 0 1-.2.08H10.5v1.78h3.65a.27.27 0 0 1 .28.28v.87c0 .08-.03.14-.08.2a.27.27 0 0 1-.2.07H9.08ZM17.7 11a.27.27 0 0 1-.2-.08.27.27 0 0 1-.07-.2v-5.9h-2a.25.25 0 0 1-.2-.07.25.25 0 0 1-.07-.18v-1c0-.08.03-.14.08-.2a.25.25 0 0 1 .18-.07h5.77a.27.27 0 0 1 .27.27v1c0 .07-.02.13-.07.18a.27.27 0 0 1-.2.08h-2v5.9c0 .08-.02.14-.07.2a.27.27 0 0 1-.2.07H17.7ZM21.28 11a.22.22 0 0 1-.17-.07.25.25 0 0 1-.06-.16v-.1l2.62-7.07a.43.43 0 0 1 .14-.21.4.4 0 0 1 .27-.09h1.4c.13 0 .22.03.28.09.07.06.11.13.14.2l2.61 7.08.02.1c0 .06-.03.11-.07.16a.22.22 0 0 1-.17.07h-1.14c-.11 0-.2-.03-.24-.08a.39.39 0 0 1-.1-.14l-.47-1.23h-3.1l-.48 1.23a.39.39 0 0 1-.1.14c-.05.05-.13.08-.24.08h-1.14Zm2.36-2.87h2.28l-1.13-3.17-1.15 3.17Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
}

export default BetaLabel;
